<template>
  <div>
    <my-header></my-header>

    <div v-show="isLoadedNormal" class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Contest {{contestId}}</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

/**
 * @typedef { import('../model/contest.js').Contest } Contest
 */
import { CONTEST_TYPE_CHAMP  } from '../model/contest.js';
import { canContestHaveGross } from '../model/contest.js';

import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'Contest',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Contest} */
      contest: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    menuItems() {
      const thisObj = this;

      const items = [
        {
          title: 'Info',
          route: {name: 'contest_info', params: {contestId: this.contestId}},
          isActive() {
            const path = thisObj.$route.path;
            return path.endsWith('info') || path.endsWith('edit');
          },
        },
        {
          title: 'Groups',
          route: {name: 'contest_groups', params: {contestId: this.contestId}},
        },
        {
          title: 'Group search',
          route: {name: 'contest_group_search', params: {contestId: this.contestId}},
        },
        {
          title: 'Statistics',
          route: {name: 'contest_stat', params: {contestId: this.contestId}},
        },
      ];

      if(this.isChampGrossMenuItemVisible) {
        const item = {
          title: 'Gross',
          route: {name: 'contest_champ_gross', params: {contestId: this.contestId}},
        };

        items.push(item);
      }

      return items;
    },

    isChampGrossMenuItemVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const contest = this.contest;
      if(contest === null) {
        return false;
      }

      if(contest.type !== CONTEST_TYPE_CHAMP) {
        return false;
      }

      return canContestHaveGross(contest.status);
    },
  },

  created() {
    this.loadContest();
  },

  methods: {
    loadContest() {
      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/contest/${this.contestId}/info`;
      HTTP.get(url)
      .then(response => {
        this.contest = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
